import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/variables.scss'
import * as store from '@/store.js';
import axios from "axios";

Vue.config.productionTip = false

let url = new URL(window.location.href)
let usecache = url.searchParams.get('usecache');
let options = {};

if (localStorage.getItem("SCSNaviOptions")){
  let savedOptions = JSON.parse(localStorage.getItem("SCSNaviOptions"));
  for (const [key, value] of Object.entries(savedOptions)) {
    console.log('loaded local Options')
    options[key] = value;
  }
}

let localData = localStorage.getItem("SCSNaviData");

if ( options.enableCache && localData ){
  console.log('loading cached data')
  init(JSON.parse(localData))
} else {
  axios.get('https://www.shoppingcityseiersberg.at/wp-json/rubikon/v1/shops').then(response => {
    console.log (response.data)
    init(response.data)
    store.setData(response.data);
  }, error => {
    console.log('axios error' + error)
  });
}

function init(data){

  new Vue({
    router,
    render: h => h(App, {props: {jsondata: data}}),

    created() {

    },

    mounted(){

    },

    data: {
      time: '',
      store: data
    }
  }).$mount('#app')
}

